import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-bootstrap';

const Checkbox = ({
  type = 'checkbox',
  helpText,
  groupClassName,
  custom = true,
  ...props
}) => {
  const [field, { touched, error }] = useField({ ...props, type });
  const isInvalid = touched && error;

  return (
    <Form.Group controlId={field.name} className={groupClassName}>
      <Form.Check
        {...field}
        {...props}
        type={type}
        isInvalid={isInvalid}
        custom={custom}
      />

      {isInvalid && (
        <Form.Control.Feedback type="invalid" className="d-block">
          {error}
        </Form.Control.Feedback>
      )}
      {helpText && <Form.Text muted>{helpText}</Form.Text>}
    </Form.Group>
  );
};

Checkbox.propTypes = {
  type: PropTypes.string,
  custom: PropTypes.bool,
  helpText: PropTypes.string,
  groupClassName: PropTypes.string,
};

export default Checkbox;
